import { getPath } from './type';
// const getCrudFlatPaths = (key: string, base: string, i18nBase: string, options: { detail?: boolean } = { detail: true }) => {
const getCrudFlatPaths = (key, base, i18nBase) => {
    const home = 'v2.sidebar.home';
    return {
        [key]: getPath(base, [home, `${i18nBase}.index`]),
        [`${key}Add`]: getPath(`${base}/add`, [home, `${i18nBase}.index`, 'action.add']),
        [`${key}Edit`]: getPath(`${base}/edit`, [home, `${i18nBase}.index`, 'action.edit']),
        // ...(options.detail && {
        //   [`${key}Detail`]: getPath(`${base}/detail`, [home, `${i18nBase}.index`, 'action.detail'])
        // })
        [`${key}Detail`]: getPath(`${base}/detail`, [home, `${i18nBase}.index`, 'action.detail'])
    };
};
export const ticketPaths = {
    ...getCrudFlatPaths('overtimeTicket', '/overtime-ticket', 'v2.sidebar.overtimeTicket'),
    ...getCrudFlatPaths('businessTripTicket', '/business-trip-ticket', 'v2.sidebar.businessTripTicket'),
    ...getCrudFlatPaths('leave', '/leave', 'v2.sidebar.leave'),
    ...getCrudFlatPaths('transportation', '/transportation', 'v2.sidebar.transportation'),
    ...getCrudFlatPaths('additionalWorkingTime', '/additional-working-time-ticket', 'v2.sidebar.additionalWorkingTime'),
    // ...getCrudFlatPaths('resignation', '/resignation-ticket', 'v2.sidebar.resignationTicket', { detail: false }) // không có detail
    ...getCrudFlatPaths('resignation', '/resignation-ticket', 'v2.sidebar.resignationTicket') // không có detail
};
